import React from 'react';

const Logo = (props) => {
  if(props.color === 'dark'){
    return (
        <img
          alt="Logo"
          src="/static/logo.png"
          {...props}
        />
      );
  }else{
    return (
      <img
        alt="Logo"
        src="/static/logo-white.png"
        {...props}
      />
    );
  }
}

export default Logo;
